/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ row: NonNullable<unknown>, text: NonNullable<unknown> }} Issue_On_RowInputs */

const en_issue_on_row = /** @type {(inputs: Issue_On_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Row ${i?.row}: ${i?.text}`)
};

/**
* | output |
* | --- |
* | "Row {row}: {text}" |
*
* @param {Issue_On_RowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_on_row = /** @type {((inputs: Issue_On_RowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_On_RowInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_on_row(inputs)
});